import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { Bank } from 'src/app/models/bank.model';
import { SchoolInformationview } from 'src/app/models/schoolinformationview.model';
import { Settings } from 'src/app/models/settings.model';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DetectlocationService } from 'src/app/services/detectlocation.service';
import { PaymentService } from 'src/app/services/payment.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { UtilService } from 'src/app/services/util.service';
import { Validators, FormControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-accountsettings',
  templateUrl: './accountsettings.component.html',
  styleUrls: ['./accountsettings.component.css']
})
export class AccountsettingsComponent implements OnInit {
  successMessage: string;
  errorMessage: string;
  isSubmitting: boolean;
  schoolid: any
  isPrivateSchool: boolean;
  allowRegByUsers: boolean;
  schooInfo: SchoolInformationview = new SchoolInformationview();
  schoolparam: any
  urlparam: any;
  banks: Bank[] = [];
  regionId: number;
  isIndividualAccount: any;
  stripeEmail: string;
  @ViewChild('bankIdField') bankIdField: NgSelectComponent;

  constructor( private schoolmanagerservice: SchoolmanagementService, private router: Router, private toastr: ToastrService, public settings: Settings,
     private paymentservice: PaymentService, public headerinfo: ComponentheaderService, private locationService: DetectlocationService) { 
    this.headerinfo.setHeaderDisplay('Account Details', [ {displaytext: 'Account Settings', route: '/account/accountsettings'},{displaytext: 'Account Details', route: '/account/accountdetails'}], [])}

  async ngOnInit() {

    await this.getSchoolInfo()
    if(!this.schooInfo) {
      this.schooInfo = new SchoolInformationview();
    }
    this.regionId = await this.locationService.getRegionID();
    this.banks = await this.paymentservice.getBanks().toPromise();   
  }

  // fetchAccountStatus() {
  //   try {
      
  //     renderAccountStatus();

  //     // Show product form if account is ready
  //     if (accountStatus.chargesEnabled) {
  //       addProductBtn.classList.remove("hidden");
  //       productsSection.classList.remove('hidden');
  //       createAccountForm.classList.add("hidden");
  //     }
  //   } catch (error) {
  //     console.error('Error fetching account status:', error);
  //   }
  // }

  async getSchoolInfo() {
    var data: any = await this.schoolmanagerservice.getSchoolDetails().toPromise();
    this.schooInfo = data.schoolInfo;
    
    if(!this.schooInfo.bankId){
      this.bankIdField?.clearModel();
    }
  }

  async onSubmit() {  
    this.isSubmitting=true
      if (this.schooInfo.id > 0 && this.regionId === 1){
        try{
          await this.schoolmanagerservice.editSchool(this.schooInfo).toPromise();
          this.toastr.success("School Updated Successfully");
        }
        catch(err){
          this.toastr.error(err);
          this.isSubmitting=false;

          return;
        }
      }
      else{
        try{
          if (Validators.email(new FormControl(this.stripeEmail)) == null){
            await this.paymentservice.createConnectAccount(this.stripeEmail, this.isIndividualAccount).toPromise();
            const data: any = await this.paymentservice.createandGotoConnectAccountLink().toPromise();
            window.open(data.url, "_blank"); 
          }
          else{
            this.toastr.error("Invalid Email Address");
          }
        }
        catch{
          this.isSubmitting=false;
          return;
        }
      }
      this.isSubmitting=false;

      this.router.navigate(['/account/accountsettings']);
    }

  }

